import { Button, styled } from "@mui/material";
import React from "react";

const QuantityButton = styled(Button)(() => ({
  border: "1px solid var(--neutral-600)",
  borderRadius: "4px",
  padding: "5px 10px",
  fontWeight: 500,
  fontSize: "14px",
  color: "var(--neutral-600)",
}));
function VariationButton({ activeTab, unit, weight, handleWeightChange }) {
  return (
    <QuantityButton
      onClick={() => handleWeightChange(weight?.id)}
      variant="outlined"
      sx={{
        border: activeTab === weight.id && "1px solid var(--primary-red-base)",
        color: activeTab === weight.id && "var(--primary-red-base)",
        backgroundColor: activeTab === weight.id && "var(--primary-red-100)",
      }}
    >
      {`${weight.itemName} ${unit}`}
    </QuantityButton>
  );
}

export default VariationButton;
